import { compose, getContext, setDisplayName } from 'recompose';
import omitProps from '@hocs/omit-props';
import { keys } from 'ramda';
import { contextTypes, IMMGRSettingsProps } from './withMMGRSettings.types';
import { useContext, useMemo } from 'react';
import { MMGRContext } from './withMMGRSettingsProvider';

/**
 * @deprecated as we are moving from HOCs to hooks, please use `useMMGRSettings` if possible
 */
export const withMMGRSettings = compose(
  setDisplayName('withMMGRSettings'),
  getContext<IMMGRSettingsProps>(contextTypes),
);

/**
 * @deprecated as we are moving from HOCs to hooks, please use `useMMGRSettings` if possible
 */
export const withoutMMGRSettings = compose(setDisplayName('withoutMMGRSettings'), omitProps(...keys(contextTypes)));

export const useMMGRSettings = () => useContext(MMGRContext);

export const useMMGRSettingsWithTokenOverride = (siteMediaToken: string) => {
  const { mmgrSettings } = useMMGRSettings();
  const topLevelMediaToken = mmgrSettings.siteMediaToken;
  return useMemo(
    () => (siteMediaToken ? { ...mmgrSettings, siteMediaToken, topLevelMediaToken } : mmgrSettings),
    [mmgrSettings, siteMediaToken],
  );
};
